// Types
import { InternationalizationRegisterTranslationProviderType } from '../../types/internationalization-register-translation.provider.type';

const isValidLanguageConfiguration = (
  response: InternationalizationRegisterTranslationProviderType
): boolean => !!(response && response?.downloadUrl && response?.lastChangedVersion);

export { isValidLanguageConfiguration };
